import { useRef } from 'react';
import useFocus from '../utility/useFocus';
import useInitialData from './useInitialData';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';
import { PromoCodesApiSliceTags, promoCodesApiSlice } from '../../store/api-slices';
import { store } from '../../store';
import useParams from '../navigation/useParams';

export default function useAppFocus() {
  const { data, refresh } = useInitialData();

  const { slug } = useParams();

  const { franchise } = data;
  const { cached_order } = useSelector((state: StoreInterface) => state.order);

  const cachedOrderRef = useRef(cached_order);
  cachedOrderRef.current = cached_order;

  const franchiseRef = useRef(franchise);
  franchiseRef.current = franchise;

  const slugRef = useRef(slug);
  slugRef.current = slug;

  useFocus(
    () => setTimeout(() => onFocus(), 50),
    () => null,
  );

  // A deferred invalidation from eb3196d7, added before RTK's focus listener was deferred.
  // It could now move to `refetchOnFocus`.
  useFocus(
    () =>
      setTimeout(() => store.dispatch(promoCodesApiSlice.util.invalidateTags([PromoCodesApiSliceTags.PromoCodes])), 50),
    undefined,
    true,
  );

  async function onFocus(): Promise<void> {
    if (!slugRef.current && franchiseRef.current?.has_multiple_companies) {
      return;
    }

    await refresh(slugRef.current, true);
  }
}
